<footer id="footer" class="section-bg">
  <div class="footer-top">
    <div class="container">
      <div class="row">
      <div class="col-lg-6">
        <div class="row">
            <div class="col-sm-6">
                <div class="footerlogo">
                  <img src="assets/img/logo/1.png" alt="Tagore Global School Kurukshetra " class="img-fluid"><br>
                </div>
                <div class="footer-links">
                  <h4>School Address</h4>
                  <ul>
                   <li>Sector 29 Global City</li>
                  <li>District : Kurukshetra</li>
                  <li>Email : info@tagoreglobalschool.in</li>
                                        <li><a href="tel:+9303350002">Contact No's : 9303350002 </a> </li>
                  <li>www.tagoreglobalschool.in<br></li>
                  </ul>
                </div>
                <div class="social-links">
                  <a href="https://www.facebook.com/tgskkr" class="facebook" target="_blank"><i class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/tgskkr18" class="instagram" target="_blank"><i class="fa fa-instagram"></i></a>
                  <a href="https://www.youtube.com/tagoreglobalschoolkkr" class="youtube" target="_blank"><i class="fa fa-youtube"></i></a>
                  <a href="https://in.linkedin.com/in/tagore-global-school-kkr-225aa4193" class="linkedin" target="_blank"><i class="fa fa-linkedin"></i></a>				
                </div>
             </div>
             <div class="col-sm-6">
                <div class="footer-links">
                  <h4>Locate Us</h4>
                    <ul>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3457.0521687958794!2d76.8786958093085!3d29.949178011997436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e412f72ac1067%3A0x86ce0f63e9367f6f!2sTagore%20Global%20School%2CKurukshetra!5e0!3m2!1sen!2sin!4v1629528436064!5m2!1sen!2sin" width="250" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                    </ul>
                </div> 
             </div>
    </div>
        </div>
    
        <div class="col-lg-6">
      <div class="row">
      <div class="col-sm-6">
              <div class="footer-links">
                <h4>About TGS</h4>
                <ul>
                  <li><a routerLink="/about/director" target="_blank">Director's Message</a></li>
                  <li><a routerLink="/about/principal" target="_blank">Principal's Message</a></li>
                  <li><a routerLink="/cbse-disclosure" target="_blank">CBSE Mandatory Disclosure</a></li>
                  <li><a href="https://drive.google.com/file/d/1tsOyPXkAjIROepNMVJqNRyoPkHkg3HNL/view?usp=sharing" target="_blank">Mandatory Public Disclosure</a></li>
                  <li><a routerLink="/transfer-certificate" target="_blank">Transfer Certificate</a></li>
                  <li><a href="http://162.241.85.240:2082">Admin</a></li>
        
        </ul>
              </div> 
      </div>
          <div class="col-sm-6">
            <div class="footer-links">
              <h4>Follows us on</h4>
              <ul>
              
              <li><a href="https://www.facebook.com/tgskkr" target="_blank">Facebook</a></li>
              <li><a href="https://www.instagram.com/tgskkr18" target="_blank">Instagram</a></li>
              <li><a href="https://www.youtube.com/tagoreglobalschoolkkr" target="_blank">Youtube</a></li>
              <li><a href="https://in.linkedin.com/in/tagore-global-school-kkr-225aa4193" target="_blank">LinkedIn</a></li>
              <li><a href="https://tgs.schoolsar.com/Website/RegisterStudent" target="_blank">Admission</a></li>
              
              </ul>
            </div> 
          </div>
      </div>
    </div>
      </div>

    </div>
  </div>

  <div class="container">
    <div class="copyright">
      ©  <a href="https://okiedokiepay.com/" target="_blank"><strong>Okie Dokie Solutions LLP</strong></a>
    </div>
    
  </div>
</footer>